
// src/hooks/useBackendPing.js
// Pings the backend on mount AND exposes a callable `pingBackend` function.
// Debounced: skips if last successful ping was < 30 seconds ago.

import { useEffect, useCallback, useRef } from 'react';

const DEBOUNCE_MS = 30_000; // 30 seconds

export function useBackendPing(backendOrigin) {
  const lastPingRef = useRef(0);

  const pingBackend = useCallback(() => {
    const now = Date.now();
    if (now - lastPingRef.current < DEBOUNCE_MS) return;

    lastPingRef.current = now;

    fetch(`${backendOrigin.replace(/\/$/, '')}/ping`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    })
      .then((res) => {
        if (!res.ok) console.warn('[ping] backend responded non-OK:', res.status);
      })
      .catch((err) => {
        console.warn('[ping] failed:', err);
        lastPingRef.current = 0; // allow immediate retry on failure
      });
  }, [backendOrigin]);

  // Fire once on mount (initial wake-up)
  useEffect(() => {
    pingBackend();
  }, [pingBackend]);

  return { pingBackend };
}
